import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  padding: ${spacing.majorScale(2)}px 0;
`

export const DescriptionContainer = styled.div`
  padding: ${spacing.majorScale(2)}px 0 ${spacing.majorScale(1)}px 0;
`
